import { instanceV2 } from '@/api/instance';

import type { GrassCampaignResponseDto } from './grass.dto';

export async function githubCallback(code: string) {
  try {
    return await instanceV2.post(
      `/v3/campaign/2024-christmas/contribute?code=${code}`,
    );
  } catch (error) {
    console.error(error);
  }
}

export async function getTotalContribution() {
  try {
    return await instanceV2.get(`/v3/campaign/2024-christmas/contributions`);
  } catch (error) {
    console.error(error);
  }
}

export async function getCertificateInfo(
  id: number,
): Promise<GrassCampaignResponseDto[] | undefined> {
  try {
    return await instanceV2.get(
      `/v3/campaign/2024-christmas/contributions/${id}`,
    );
  } catch (error) {
    console.error(error);
  }
}
